import React from "react";

function BS4_Quiz() {
  return (
    <div>
      <h1>BS4_Quiz Component</h1>
      <p>This is the BS4_Quiz tutorial page content.</p>
    </div>
  );
}

export default BS4_Quiz;
